import dayjs from "dayjs";

import { ProductFormByBarcode } from "@/types/form";

export const checkIsStatisticNotBeforeMotivation = (
    statisticDate: string,
    motivationDate: string,
) => {
    if (!statisticDate || !motivationDate) return false;

    return dayjs(statisticDate) < dayjs(motivationDate);
};

export const calculateOrderSum = (
    formValues: ProductFormByBarcode = {},
): number => {
    return Object.values(formValues).reduce((sum, product) => {
        return sum + (product?.price || 0) * (product?.count || 0);
    }, 0);
};
